import { FC } from 'react'

import './style.scss'
import { AuthRoles } from '../../models'
import { GotoTop, TitleMain, Modal, useModal, Button } from '../../components/UI'
import { Header, HeaderPublic, Footer } from '../'
import { Menu } from '../../components'
import { Survey } from '../../components/Survey'

type LayoutProps = {
  type?: 'public' | '',
  role?: AuthRoles,
  menu?: boolean,
  background?: string,
  titleMain?: number
}

const Layout:FC<LayoutProps> = ({ children, type = '', role = '', background = '', menu = false, titleMain = 0 })  => {
  const modal = useModal()

  return (
    <>
      {type === 'public' ? <HeaderPublic /> : <Header role={role} /> }

      <main className={`${!titleMain ? 'main' : ''} bg-main ${background ? 'bg-' + background : ''}`}>
        {!!titleMain && <TitleMain background={titleMain} />}

        {type === 'public' ?
            <>{children}</>
          :
            <>
              {menu ?
                  <div className="d-flex w-full">
                    <div className="menu-wrapper">
                      <Menu role={role} />
                      <Button size="md" className="mt-20" onClick={() => modal.open()}>Comentarios / sugerencias</Button>
                    </div>
                    <div className="content-wrapper">
                      {children}
                    </div>
                  </div>
                :
                  <>{children}</>
              }
            </>
        }
      </main>

      <Footer type={type} role={role} />
      <GotoTop />

      <Modal show={modal.show} maxWidth="490px" onClose={() => modal.close()}>
        {modal.show && <Survey />}
      </Modal>
    </>
  )
}

export { Layout }